<div class="cpsnContainer">
    <div class="cpsnLogo"><img src="assets/images/cps-notifications.png"></div>
    <div class="cpsnLabel">
        <a [href]="cpsNotificationURL" target="_blank"><u>{{ 'MessageCenter.cpsn.label' | translate }}</u> <span class="new-window-icon"></span></a>
    </div>
</div>